import React, { useState, useEffect, useRef } from 'react';

export default function ChatInterface() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);



const sendMessage = async () => {
  if (!input.trim()) return;

  const newMessage = { role: 'user', content: input };
  setMessages(prev => [...prev, newMessage]);
  setInput('');
  setIsLoading(true);

  try {
    let responseText = '';

    if (input.startsWith('/imagine')) {
      const prompt = input.replace('/imagine', '').trim();
      const res = await fetch('https://snapi.skillnation.ai/generate-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt }),
      });

      const blob = await res.blob();
      const imageUrl = URL.createObjectURL(blob);
      setMessages(prev => [...prev, { role: 'assistant', content: <img src={imageUrl} className="max-w-xs rounded-lg border" /> }]);
    } else {
      const res = await fetch('https://snapi.skillnation.ai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: input }),
      });

      const data = await res.json();
      responseText = data.response;
      setMessages(prev => [...prev, { role: 'assistant', content: responseText }]);

      // 🧠 NEW: If the assistant rewrote prompt (starts with "Imagine ..."), send it to image generator
      if (responseText.toLowerCase().startsWith('imagine ')) {
        const newPrompt = responseText.replace(/^imagine\s*/i, '');
        const imageRes = await fetch('https://snapi.skillnation.ai/generate-image', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prompt: newPrompt }),
        });

        const blob = await imageRes.blob();
        const imageUrl = URL.createObjectURL(blob);
        setMessages(prev => [...prev, { role: 'assistant', content: <img src={imageUrl} className="max-w-xs rounded-lg border" /> }]);
      }
    }
  } catch (err) {
    setMessages(prev => [...prev, { role: 'assistant', content: '❌ Error fetching response.' }]);
  }

  setIsLoading(false);
};

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-xs p-3 rounded-lg shadow ${
                msg.role === 'user'
                  ? 'bg-blue-500 text-white'
                  : 'bg-white text-black border'
              }`}
            >
              {msg.content}
            </div>
          </div>
        ))}
        {isLoading && <div className="text-gray-500">Typing...</div>}
        <div ref={messagesEndRef} />
      </div>

      <div className="p-4 border-t flex gap-2">
        <input
          type="text"
          className="flex-1 p-2 rounded border"
          placeholder="Type a message or use /imagine ..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
        />
        <button
          onClick={sendMessage}
          className="bg-green-500 text-white px-4 py-2 rounded"
        >
          Send
        </button>
      </div>
    </div>
  );
}
